import Relay from 'react-relay';
/**
*  TurnOn lightGroup mutation
*/
export default class TurnOnLightGroupMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation Mutation{
      turnOnLightGroup
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
        lightGroupId: this.props.lightGroupId,
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on turnOnLightGroupPayload @relay(pattern: true){
        clientMutationId,
        viewer{
            id
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id,
        },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
          id
      }
    `,
  };
}



// WEBPACK FOOTER //
// ./src/mutations/Venue/TurnOnLightGroupMutation.js